module.exports = __webpack_public_path__ + "assets/img/news (9).e376acf5.png";